import React from "react";
import styles from "./index.module.css";
import {Button, Menu} from "semantic-ui-react";
import {Link, RouteComponentProps} from "react-router-dom";
import {Route, Switch} from "react-router";
import PatientInfoTab from "./EditorTabs/PatientInfoTab";
import PatientFilesTab from "./EditorTabs/PatientFilesTab";
import CureProgramTab from "./EditorTabs/CureProgramTab";
import InteractionHistoryTab from "./EditorTabs/InteractionHistoryTab";
import DeviationTab from "./EditorTabs/Deviation";
import {Patient} from "../dashboard";
import agent from "../../agent";
import PatientTestResultsTab from "./EditorTabs/test/PatientTestResultsTab";
import {Utils} from "../../helpers/Utils";
import {AppMode, GeneralTitleCase, getGeneralTitle, getPatientTitle, PatientTitleCase} from "../../utils/common";
import {extractReturnUrl, handleGoBack} from "../../helpers/TablePageUtils";
import { Location } from 'history';
import { textLabels } from "../../consts/textLabels";


interface MatchParams {
    id: string;
}

interface Props extends RouteComponentProps<MatchParams> {}

interface State {
    activeTab: string,
    //prevPath: string,
    patient?: Patient,
    returnUrl: string
}

class PatientEditor extends React.PureComponent<Props, State> {
    private readonly FALLBACK_URL = "/dashboard/patients";

    state: State = {
        activeTab: 'patientInfo',
        //prevPath: '/dashboard/patients',
        returnUrl: this.FALLBACK_URL,
    };

    getPatientId = (): string => {
        return this.props.match ? this.props.match.params.id : '';
    }

    async componentDidMount() {
        const extractedUrl = extractReturnUrl(this.props.history.location, this.FALLBACK_URL);
        this.setState({ returnUrl: extractedUrl });

        this.setState({patient: await agent.PatientProvider.open(this.getPatientId())});

        const currentTab: string = this.props.history ? this.props.history.location.pathname : '';

        this.setState({
            activeTab: currentTab.split("/")[5],
            //prevPath: this.props.history.location.state ? this.props.history.location.state.prevPath : '/dashboard/patients'
        });
    };

    handleItemClick = (name: string): void => {
        this.setState({
            activeTab: name
        });
    };

    handleGoBack = (e: React.MouseEvent) => {
        e.preventDefault();
        handleGoBack(this.props.history, this.state.returnUrl, this.FALLBACK_URL);
    };

    render() {
        const activeItem: string = this.state.activeTab;
        const currentPath: string = this.props.match ? this.props.match.url : '';
        const patientId: string = this.getPatientId();

        return (
            <div className={styles.editor}>
                <div className={styles.patientEditorTop}>
                    {this.state.patient && <p style={{fontWeight: "bold"}}>
                        {`${this.state.patient.surname} ${this.state.patient.name} ${this.state.patient.middlename}`}</p>}
                    <Button
                            className={styles.button}
                            color={'grey'}
                            type={'submit'}
                            content={textLabels.returnButton}
                            onClick={this.handleGoBack}
                        />
                </div>
                <Menu stackable>

                    <Menu.Item
                        as={Link}
                        to={`${currentPath}/patientInfo`}
                        content={`Данные ${getPatientTitle(PatientTitleCase.a)}`}
                        active={activeItem === 'patientInfo'}
                        onClick={() => {
                            this.handleItemClick('patientInfo');
                        }}
                    />

                    <Menu.Item
                        as={Link}
                        to={`${currentPath}/cureProgram`}
                        content={getGeneralTitle(GeneralTitleCase.cureProgram)}
                        active={activeItem === 'cureProgram'}
                        onClick={() => {
                            this.handleItemClick('cureProgram');
                        }}
                    />

                    <Menu.Item
                        as={Link}
                        to={`${currentPath}/patientFiles`}
                        content={`Файлы ${getPatientTitle(PatientTitleCase.a)}`}
                        active={activeItem === 'patientFiles'}
                        onClick={() => this.handleItemClick('patientFiles')}
                    />
                    {Utils.vomode()==AppMode.PATIENT&&
                    <Menu.Item
                        as={Link}
                        to={`${currentPath}/patientTestResults`}
                        content={Utils.vomode()!=AppMode.PATIENT ? 'Документы' : 'Анализы'}
                        active={activeItem === 'patientTestResults'}
                        onClick={() => this.handleItemClick('patientTestResults')}
                    />}

                    <Menu.Item
                        as={Link}
                        to={`${currentPath}/interactionHistory`}
                        content={'История взаимодействия'}
                        active={activeItem === 'interactionHistory'}
                        onClick={() => this.handleItemClick('interactionHistory')}
                    />

                    <Menu.Item
                        as={Link}
                        to={`${currentPath}/deviation`}
                        content={'Отклонения'}
                        active={activeItem === 'deviation'}
                        onClick={() => this.handleItemClick('deviation')}
                    />
                </Menu>

                <Switch>
                    <Route path={`${currentPath}/patientInfo`}>
                        <PatientInfoTab id={patientId} match={this.props.match} backUrl={this.state.returnUrl}/>
                    </Route>
                    <Route path={`${currentPath}/cureProgram`}>
                        <CureProgramTab id={patientId}/>
                    </Route>
                    <Route path={`${currentPath}/patientFiles`}>
                        <PatientFilesTab id={patientId}/>
                    </Route>
                    <Route path={`${currentPath}/patientTestResults`}>
                        <PatientTestResultsTab patientId={patientId}/>
                    </Route>
                    <Route path={`${currentPath}/interactionHistory`}>
                        <InteractionHistoryTab patientId={patientId}/>
                    </Route>
                    <Route path={`${currentPath}/deviation`}>
                        <DeviationTab patientId={patientId}/>
                    </Route>
                </Switch>

            </div>
        );
    }
}

export default PatientEditor;
